var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pc-signup-page"},[_vm._m(0),_c('CategorySection'),_c('HomeFooter',{staticClass:"signup-footer"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"signup-banner"},[_c('img',{attrs:{"src":require("../assets/pc/banner1.png"),"alt":"重庆市大学生创意传播作品大赛"}})])
}]

export { render, staticRenderFns }